export default __webpack_public_path__ + "static/media/note.d155ceac.png";